import { DirectList, LinearDirectList, RectDirectList, ShapeDirectionList } from '@editor/src/js/constants';
import {
    LINEAR_GRADIENT,
    RADIAL_GRADIENT,
    RECT_GRADIENT,
    SHAPE_GRADIENT,
    FillType,
    FillTypes,
    TileOffsetSpinOptions,
    AllSpinOptions,
    angleStyle,
    buttonStyle,
    iconStyle,
    textStyle,
} from '@tencent/drawing-drawer-components/lib/constants';

export const FillTypeMap = {
    noFill: FillType.NO_FILL,
    solidFill: FillType.SOLID_FILL,
    gradFill: FillType.GRADUAL_FILL,
    image: FillType.IMAGE_FILL,
    pattFill: FillType.PATT_FILL,
};

export const DirectOptions = DirectList.map((item: any) => {
    item.key = item;
    item.content = item.title;
    return item;
});

export const RectDirectOptions = RectDirectList.map((item: any) => {
    item.key = item;
    item.content = item.title;
    return item;
});

export const LinearDirectOptions = LinearDirectList.map((item: any) => {
    item.key = item;
    item.content = item.title;
    return item;
});

export const ShapeDirectOptions = ShapeDirectionList.map((item: any) => {
    item.key = item;
    item.content = item.title;
    return item;
});

export const selectStyle = {
    maxWidth: 116,
};

export {
    LINEAR_GRADIENT,
    RADIAL_GRADIENT,
    RECT_GRADIENT,
    SHAPE_GRADIENT,
    FillType,
    FillTypes,
    TileOffsetSpinOptions,
    AllSpinOptions,
    angleStyle,
    buttonStyle,
    iconStyle,
    textStyle,
};
